import dayjs from "dayjs";
/**
 * Convert number (minutes since 5:00 AM) to 12-hour time format
 * 
 * eg. 0 => 05:00 am
 *     630 => 03:30 pm
 *     690 => 04:30 pm
 */
export const numberToTimeString = (number: number): string => {
  const base = dayjs().startOf('day').add(5, 'hour'); // Start at 5:00 AM
  const time = base.add(number, 'minute');
  return time.format("hh:mm a");
};